module.exports = __webpack_public_path__ + "img/max-file-sync--json.374bf4c2.svg";